import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { _GlobalConstants } from '../../../services/globalConstants.service';
import {Observable} from "rxjs/Observable";
import {_ReferenceDataService} from "../../../services/referenceData.service";
import {TranslateService} from "@ngx-translate/core";

declare let jQuery:any;
declare let $ :any;
declare let globalConstants:any;
declare let defaultGridViewSettings;
declare let initrowdetails;
declare let getGlobalConstantDisplay;

@Component({
  selector: 'fx-orders-h',
  templateUrl: './fx-orders-h.component.html',
  styleUrls: ['./fx-orders-h.component.css'],
})

export class FXOrdersHistory implements OnInit, OnDestroy {

  private subscription: any;
  private globalConstants: any;
  private accounts: any;
  private liquidityProviders: any;

  constructor (private route: ActivatedRoute, private titleService: Title, private constants: _GlobalConstants, private translate: TranslateService, private referenceData: _ReferenceDataService) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | FX Order Recommendation Summary");

    this.subscription = Observable.forkJoin(this.constants.getGlobalConstants(), this.referenceData.getAccounts(), this.referenceData.getLiquidityProviders()).subscribe((res: Array<any>) => {
      this.globalConstants = res[0];
      this.accounts = res[1];
      this.liquidityProviders = res[2];
      this.globalReady();
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  globalReady() {
    let translate = this.translate;
    let constants = this.constants;
    let accounts = this.accounts;
    let liquidityProviders = this.liquidityProviders;

      // init main tab widgets.
      let initTabWidgets = function (tab) {
          switch (tab) {
              case 0:
                  initGridFXOrdersBySweepCriteriaMatchTab();
                  break;
              case 1:
                  initGridFXOrdersByOrderTab();
                  break;
          }
      }

      $('#jqxTabs').jqxTabs({ width: '100%', autoHeight: 'true', initTabContent: initTabWidgets });
      /**
          Sweep Criteria Match Tab Begins
      **/
      function initGridFXOrdersBySweepCriteriaMatchTab() {
          // initialize main jqxGrid
          let source = {
              datafields : [{
                  name : 'eventTimestamp',
                  map  : 'ruleMatchEvent>eventTimestamp',
                  type : 'date',
                  format: 'yyyy-MM-dd HH:mm:ss.fff'
              }, {
                  name : 'eventAction1',
                  map  : 'ruleMatchEvent>eventAction',
                  type : 'string'
              }, {
                  name : 'eventActionDisplayName',
                  type : 'string',
                  value: 'eventAction1',
                  values: {
                      source: constants.getTranslatedValues('resources.ruleMatchEvent.action'),
                      value: 'value',
                      name: 'display'
                  }
              }, {
                  name : 'ruleMatchEventDecisions',
                  map  : 'ruleMatchEvent>decisions',
                  type : 'array'
              }, {
                  name : 'fxOrderUpdates',
                  type : 'array'
              }, {
                  name : 'ruleMatchEventFinalAllocations',
                  type : 'array'
              }],
              id : 'eventId',
              url : '/ajax/fx-orders/summary-by-rule-match',
              type : 'GET',
              async : true
          };

          let settings = defaultGridViewSettings("#jqxGridFXOrdersBySweepCriteriaMatch", source);
          settings.columns = [{
              text : 'Timestamp',
              columntype : 'datetimeinput',
              datafield : 'eventTimestamp',
              cellsformat : 'MM/dd/yyyy HH:mm:ss.fff',
              width : '160'
          }, {
              text : 'Exposure Evaluation Event',
              columntype : 'textbox',
              datafield : 'eventActionDisplayName',
              width : '500'
          }];

          let initrowdetails = function (index, parentElement, gridElement, datarecord) {
              let tabsdiv = null;
              tabsdiv = $($(parentElement).children()[0]);
              $(tabsdiv).jqxTabs({
                      width : '100%',
                      height : '100%',
                      initTabContent : function(tab) {
                          switch (tab) {
                              case 0 :
                                  initDecisionsTab(datarecord.ruleMatchEventDecisions);
                                  break;
                              case 1 :
                                  initFXOrdersTab("#jqxGridFXOrdersSweepCriteriaMatch",datarecord.fxOrderUpdates);
                                  break;
                              case 2 :
                                  if (datarecord.ruleMatchEventFinalAllocations !== undefined) {
                                      initRuleAllocationsTab(datarecord.ruleMatchEventFinalAllocations);
                                  }
                                  break;
                          }
                      }
                  });
                  if (datarecord.ruleMatchEventFinalAllocations === undefined) {
                      $("#ruleAccountAllocationsTab").hide();
                  }
          }

          settings.height = 700;
          settings.rowdetails = true;
          settings.initrowdetails = initrowdetails;
          settings.rowdetailstemplate = {
              rowdetails : "<div id='jqxTab' style='overflow: hidden;'>\
                  <ul>\
                      <li style='margin-left: 30px;'>Decisions</li>\
                      <li>Orders</li>\
                      <li id='ruleAccountAllocationsTab'>Account Allocations</li>\
                  </ul>\
                  <div style='overflow: hidden;'>\
                      <div style='border:none' id='jqxGridDecisions'></div>\
                  </div>\
                  <div style='overflow: hidden;'>\
                      <div style='border:none' id='jqxGridFXOrdersSweepCriteriaMatch'></div>\
                  </div>\
                  <div style='overflow: hidden;'>\
                      <div style='border:none' id='jqxGridRuleAccountAllocations'></div>\
                  </div>\
              </div>",
              rowdetailsheight : 500,
              rowdetailshidden : true
          };

          $("#jqxGridFXOrdersBySweepCriteriaMatch").jqxGrid(settings);
      }

      function initDecisionsTab(data) {

          data.forEach(x => {
            x.decisionDisplay = translate.instant('backend.resources.ruleMatchEventDecision.decision.' + x.decision, x.details);
          });

          let source = {
              localdata : data,
              datafields : [{
                  name : 'decision',
                  type : 'string'
              },{
                  name : 'decisionDisplay',
                  type : 'string',
              },{
                  name : 'accountId',
                  type : 'string'
              },{
                name : 'accountDisplay',
                type : 'string',
                value: 'accountId',
                values: {
                  source: accounts,
                  value: 'accountId',
                  name: 'displayName'
                }
              },{
                  name : 'targetCurrency',
                  type : 'string'
              },{
                  name : 'counterCurrency',
                  type : 'string'
              },{
                  name : 'totalExposureQuantity',
                  type : 'string'
              }, {
                  name : 'targetExposureQuantity',
                  type : 'string'
              }, {
                  name : 'totalTargetExecutedQuantity',
                  type : 'string'
              }, {
                  name : 'totalTargetPendingQuantity',
                  type : 'string'
              }, {
                  name : 'totalCounterExecutedQuantity',
                  type : 'string'
              }, {
                  name : 'totalCounterPendingQuantity',
                  type : 'string'
              }, {
                  name : 'purpose',
                  type : 'string'
              },{
                  name : 'purposeDisplayName',
                  type : 'string',
                  value: 'purpose',
                  values: {
                      source: constants.getTranslatedValues('common.staticValues.purpose'),
                      value: 'value',
                      name: 'display'
                  }
              }, {
                  name : 'settlementDate',
                  type : 'date',
                  format:'yyyy-MM-dd'
              }]
          };
          let settings = defaultGridViewSettings("#jqxGridDecisions", source);
          settings.width = '97%';
          settings.height = '99%';
          settings.columns = [{
              text : 'Decision',
              columntype : 'textbox',
              datafield : 'decisionDisplay',
              width : '300'
          },{
              text : 'Account',
              columntype : 'textbox',
              datafield : 'accountDisplay',
              width : '100'
          },{
              text : 'Target Ccy',
              columntype : 'textbox',
              datafield : 'targetCurrency',
              width : '80'
          }, {
              text : 'Counter Ccy',
              columntype : 'textbox',
              datafield : 'counterCurrency',
              width : '80'
          }, {
              text : 'Total Exposure Qty',
              columntype : 'textbox',
              datafield : 'totalExposureQuantity',
              width : '150'
          }, {
              text : 'Target Exposure Qty',
              columntype : 'textbox',
              datafield : 'targetExposureQuantity',
              width : '150'
          }, {
              text : 'Total Target Ccy Executed Qty',
              columntype : 'textbox',
              datafield : 'totalTargetExecutedQuantity',
              width : '200'
          }, {
              text : 'Total Target Ccy Pending Qty',
              columntype : 'textbox',
              datafield : 'totalTargetPendingQuantity',
              width : '200'
          }, {
              text : 'Total Counter Ccy Executed Qty',
              columntype : 'textbox',
              datafield : 'totalCounterExecutedQuantity',
              width : '200'
          }, {
              text : 'Total Counter Ccy Pending Qty',
              columntype : 'textbox',
              datafield : 'totalCounterPendingQuantity',
              width : '200'
          }, {
              text : 'Purpose',
              columntype : 'textbox',
              datafield : 'purposeDisplayName',
              width : '80'
          }, {
              text : 'Settlement Date',
              columntype : 'datetimeinput',
              datafield : 'settlementDate',
              cellsformat:'yyyy-MMM-dd',
              width : '120'
          }];

          $("#jqxGridDecisions").jqxGrid(settings);
      }

      function initFXOrdersTab(gridName, data) {
          let source = {
              localdata : data,
              datafields : [{
                  name : 'updateTimestamp',
                  map : 'fxOrder>updateTimestamp',
                  type : 'date',
                  format: 'yyyy-MM-dd HH:mm:ss.fff'
              }, {
                  name : 'orderState',
                  map  : 'fxOrder>orderState',
                  type : 'string'
              }, {
                  name : 'orderStateDisplayName',
                  type : 'string',
                  value: 'orderState',
                  values: {
                      source: constants.getTranslatedValues('resources.orderUpdate.state'),
                      value: 'value',
                      name: 'display'
                  }
              }, {
                  name : 'externalOrderId',
                  map  : 'fxOrder>externalOrderId',
                  type : 'string'
              }, {
                  name : 'currencyPair',
                  map  : 'fxOrder>currencyPair',
                  type : 'string'
              }, {
                  name : 'currency',
                  map  : 'fxOrder>currency',
                  type : 'string'
              }, {
                  name : 'liquidityProviderId',
                  map  : 'fxOrder>liquidityProviderId',
                  type : 'string'
              }, {
                  name : 'liquidityProviderDisplay',
                  type : 'string',
                  value: 'liquidityProviderId',
                  values: {
                    source: liquidityProviders,
                    value: 'value',
                    name: 'display'
                }
              }, {
                  name : 'contractType',
                  map  : 'fxOrder>contractType',
                  type : 'string'
              }, {
                  name : 'contractTypeDisplayName',
                  type : 'string',
                  value: 'contractType',
                  values: {
                      source: constants.getTranslatedValues('resources.fxInstrument.type'),
                      value: 'value',
                      name: 'display'
                  }
              }, {
                  name : 'orderType',
                  map  : 'fxOrder>orderType',
                  type : 'string'
              }, {
                  name : 'orderTypeDisplayName',
                  type : 'string',
                  value: 'orderType',
                  values: {
                      source: constants.getTranslatedValues('resources.order.type'),
                      value: 'value',
                      name: 'display'
                  }
              }, {
                  name : 'side',
                  map  : 'fxOrder>positionAction',
                  type : 'string'
              }, {
                  name : 'sideDisplayName',
                  type : 'string',
                  value: 'side',
                  values: {
                      source: constants.getTranslatedValues('resources.order.side'),
                      value: 'value',
                      name: 'display'
                  }
              }, {
                  name : 'orderQuantity',
                  map  : 'fxOrder>orderQuantity',
                  type : 'string'
              }, {
                  name : 'orderSpotPrice',
                  map  : 'fxOrder>orderSpotPrice',
                  type : 'string'
              }, {
                  name : 'orderForwardPoints',
                  map  : 'fxOrder>orderForwardPoints',
                  type : 'string'
              }, {
                  name : 'orderOutrightPrice',
                  map  : 'fxOrder>orderOutrightPrice',
                  type : 'string'
              }, {
                  name : 'quantityExecuted',
                  map  : 'fxOrder>quantityExecuted',
                  type : 'string'
              }, {
                  name : 'valueDate',
                  map  : 'fxOrder>valueDate',
                  type : 'date',
                  format : 'yyyy-MM-dd'
              }, {
                  name : 'allocations',
                  map  : 'fxOrder>allocations'
              }, {
                  name : 'fxOrderUpdates'
              }]
          };

          let settings = defaultGridViewSettings(gridName, source);
          settings.width = '97%';
          settings.height = '99%';
          settings.columns =  [
          {
              text : 'Last Updated',
              columntype : 'datetimeinput',
              datafield : 'updateTimestamp',
              cellsformat : 'MM/dd/yyyy HH:mm:ss.fff',
              width : '160'
          }, {
              text : 'Order State',
              columntype : 'textbox',
              datafield : 'orderStateDisplayName',
              width : '120'
          }, {
              text : 'External Order ID',
              columntype : 'textbox',
              datafield : 'externalOrderId',
              width : '150'
          }, {
              text : 'Ccy Pair',
              columntype : 'textbox',
              datafield : 'currencyPair',
              width : '80'
          }, {
              text : 'Ccy',
              columntype : 'textbox',
              datafield : 'currency',
              width : '50'
          }, {
              text : 'Broker',
              columntype : 'textbox',
              datafield : 'liquidityProviderDisplay',
              width : '80'
          }, {
              text : 'Contract Type',
              columntype : 'textbox',
              datafield : 'contractTypeDisplayName',
              width : '100'
          }, {
              text : 'Order Type',
              columntype : 'textbox',
              datafield : 'orderTypeDisplayName',
              width : '100'
          }, {
              text : 'Side',
              columntype : 'textbox',
              datafield : 'sideDisplayName',
              width : '50'
          }, {
              text : 'Quantity',
              columntype : 'textbox',
              datafield : 'orderQuantity',
              width : '80'
          }, {
              text : 'Spot Px',
              columntype : 'textbox',
              datafield : 'orderSpotPrice',
              width : '80'
          }, {
              text : 'Fwd Pts',
              columntype : 'textbox',
              datafield : 'orderForwardPoints',
              width : '80'
          }, {
              text : 'Outright Px',
              columntype : 'textbox',
              datafield : 'orderOutrightPrice',
              width : '80'
          }, {
              text : 'Executed',
              columntype : 'textbox',
              datafield : 'quantityExecuted',
              width : '80'
          }, {
              text : 'Value Date',
              columntype : 'datetimeinput',
              cellsformat: 'yyyy-MMM-dd',
              datafield : 'valueDate',
              width : '100'
          }];

          let initrowdetails = function(index, parentElement, gridElement, datarecord) {
              let tabsdiv = null;
              tabsdiv = $($(parentElement).children()[0]);
              $(tabsdiv).jqxTabs({
                  width : '100%',
                  height : '100%',
                  initTabContent : function(tab) {
                      switch (tab) {
                          case 0 :
                              initOrderUpdateTab("#jqxGridSweepCriteriaOrderUpdates", datarecord.fxOrderUpdates);
                              break;
                          case 1 :
                              if (datarecord.allocations !== undefined) {
                                  initOrderAllocationsTab("#jqxGridSweepCriteriaAccountAllocations",datarecord.allocations);
                              }
                              break;
                      }
                  }
              });
              if (datarecord.allocations === undefined) {
                  $("#accountAllocationsTab").hide();
              }
          }
          settings.rowdetails = true;
          settings.initrowdetails = initrowdetails;
          settings.rowdetailstemplate = {
              rowdetails : "<div id='jqxTab' style='overflow: hidden;'>\
                              <ul>\
                                  <li style='margin-left: 30px;'>Order Updates</li>\
                                  <li id='accountAllocationsTab'>Account Allocations</li>\
                              </ul>\
                              <div style='overflow: hidden;'>\
                                  <div style='border:none' id='jqxGridSweepCriteriaOrderUpdates'></div>\
                              </div>\
                              <div style='overflow: hidden;'>\
                                  <div style='border:none' id='jqxGridSweepCriteriaAccountAllocations'></div>\
                              </div>\
                          </div>",
              rowdetailsheight : 500,
              rowdetailshidden : true
          };

          $(gridName).jqxGrid(settings);
      }

      function initOrderAllocationsTab(gridName, data) {

          let source = {
              localdata : data,
              datafields : [{
                  name : 'accountId',
                  type : 'string'
              }, {
                name : 'accountDisplay',
                type : 'string',
                value: 'accountId',
                values: {
                  source: accounts,
                  value: 'accountId',
                  name: 'displayName'
                }
              }, {
                  name : 'currency',
                  type : 'string'
              }, {
                  name : 'quantity',
                  type : 'string'
              }]
          };
          let settings = defaultGridViewSettings(gridName, source);
          settings.width = '97%';
          settings.height = '99%';
          settings.columns = [{
              text : 'Account',
              columntype : 'textbox',
              datafield : 'accountDisplay',
              width : '25%'
          }, {
              text : 'Ccy',
              columntype : 'textbox',
              datafield : 'currency',
              width : '25%'
          }, {
              text : 'Quantity',
              columntype : 'textbox',
              datafield : 'quantity',
              width : '25%'
          }];

          $(gridName).jqxGrid(settings);
      }

      function initRuleAllocationsTab(data) {
          let source = {
              localdata : data,
              datafields : [{
                name : 'accountId',
                type : 'string'
              }, {
                name : 'accountDisplay',
                type : 'string',
                value: 'accountId',
                values: {
                  source: accounts,
                  value: 'accountId',
                  name: 'displayName'
                }
              }, {
                  name : 'currency',
                  type : 'string'
              }, {
                  name : 'quantity',
                  type : 'string'
              }, {
                  name : 'externalOrderId',
                  type : 'string'
              }, {
                  name : 'valueDate',
                  type : 'date',
                  format : 'yyyy-MM-dd'
              }]
          };
          let settings = defaultGridViewSettings("#jqxGridRuleAccountAllocations", source);
          settings.width = '97%';
          settings.height = '99%';
          settings.columns = [{
              text : 'Account',
              columntype : 'textbox',
              datafield : 'accountDisplay',
              width : '20%'
          }, {
              text : 'Ccy',
              columntype : 'textbox',
              datafield : 'currency',
              width : '20%'
          }, {
              text : 'Quantity',
              columntype : 'textbox',
              datafield : 'quantity',
              width : '20%'
          }, {
              text : 'External Order IDs',
              columntype : 'textbox',
              datafield : 'externalOrderId',
              width : '20%',
              cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties) {
                  if (value) {
                      return defaulthtml;
                  }
                  else {
                      return '<div style="font-style: italic; overflow: hidden; text-overflow: ellipsis; padding-bottom: 2px; text-align: left; margin-right: 2px; margin-left: 4px; margin-top: 4px;">Internal</div>';
                  }
              }
          }, {
              text : 'Value Date',
              columntype : 'datetimeinput',
              datafield : 'valueDate',
              width : '20%',
              cellsformat : 'yyyy-MMM-dd'
          }];

          $("#jqxGridRuleAccountAllocations").jqxGrid(settings);
      }

      /**
          FxOrder Summary by Order Update begins
      **/
      function initGridFXOrdersByOrderTab() {
          // initialize main jqxGrid
          let source = {
              datafields : [{
                  name : 'updateTimestamp',
                  map : 'fxOrder>updateTimestamp',
                  type : 'date',
                  format: 'yyyy-MM-dd HH:mm:ss.fff'
              }, {
                  name : 'orderState',
                  map  : 'fxOrder>orderState',
                  type : 'string'
              }, {
                  name : 'orderStateDisplayName',
                  type : 'string',
                  value: 'orderState',
                  values: {
                      source: constants.getTranslatedValues('resources.orderUpdate.state'),
                      value: 'value',
                      name: 'display'
                  }
              }, {
                  name : 'externalOrderId',
                  map  : 'fxOrder>externalOrderId',
                  type : 'string'
              }, {
                  name : 'currencyPair',
                  map  : 'fxOrder>currencyPair',
                  type : 'string'
              }, {
                  name : 'currency',
                  map  : 'fxOrder>currency',
                  type : 'string'
              }, {
                  name : 'liquidityProviderId',
                  map  : 'fxOrder>liquidityProviderId',
                  type : 'string'
              }, {
                  name : 'liquidityProviderDisplay',
                  type : 'string',
                  value: 'liquidityProviderId',
                  values: {
                    source: liquidityProviders,
                    value: 'liquidityProviderId',
                    name: 'displayName'
                  }
              }, {
                  name : 'contractType',
                  map  : 'fxOrder>contractType',
                  type : 'string'
              }, {
                  name : 'contractTypeDisplayName',
                  type : 'string',
                  value: 'contractType',
                  values: {
                      source: constants.getTranslatedValues('resources.fxInstrument.type'),
                      value: 'value',
                      name: 'display'
                  }
              }, {
                  name : 'orderType',
                  map  : 'fxOrder>orderType',
                  type : 'string'
              }, {
                  name : 'orderTypeDisplayName',
                  type : 'string',
                  value: 'orderType',
                  values: {
                      source: constants.getTranslatedValues('resources.order.type'),
                      value: 'value',
                      name: 'display'
                  }
              }, {
                  name : 'side',
                  map  : 'fxOrder>positionAction',
                  type : 'string'
              }, {
                  name : 'sideDisplayName',
                  type : 'string',
                  value: 'side',
                  values: {
                      source: constants.getTranslatedValues('resources.order.side'),
                      value: 'value',
                      name: 'display'
                  }
              }, {
                  name : 'orderQuantity',
                  map  : 'fxOrder>orderQuantity',
                  type : 'string'
              }, {
                  name : 'orderSpotPrice',
                  map  : 'fxOrder>orderSpotPrice',
                  type : 'string'
              }, {
                  name : 'orderForwardPoints',
                  map  : 'fxOrder>orderForwardPoints',
                  type : 'string'
              }, {
                  name : 'orderOutrightPrice',
                  map  : 'fxOrder>orderOutrightPrice',
                  type : 'string'
              }, {
                  name : 'quantityExecuted',
                  map  : 'fxOrder>quantityExecuted',
                  type : 'string'
              }, {
                  name : 'valueDate',
                  map  : 'fxOrder>valueDate',
                  type : 'date',
                  format : 'yyyy-MM-dd'
              }, {
                  name : 'allocations',
                  map  : 'fxOrder>allocations',
                  type : 'array'
              }, {
                  name : 'fxOrderUpdates'
              }, {
                  name : 'ruleMatchEvent'
              }],
              id : 'eventId',
              url : '/ajax/fx-orders/summary-by-order',
              type : 'GET',
              async : true
          };
          let settings = defaultGridViewSettings("#jqxGridFXOrdersByOrder", source);
          settings.height = 700;
          settings.columns = [{
              text : 'Last Updated',
              columntype : 'datetimeinput',
              datafield : 'updateTimestamp',
              cellsformat : 'MM/dd/yyyy HH:mm:ss.fff',
              width : '150'
          }, {
              text : 'Order State',
              columntype : 'textbox',
              datafield : 'orderStateDisplayName',
              width : '120'
          }, {
              text : 'External Order ID',
              columntype : 'textbox',
              datafield : 'externalOrderId',
              width : '150'
          }, {
              text : 'Ccy Pair',
              columntype : 'textbox',
              datafield : 'currencyPair',
              width : '80'
          }, {
              text : 'Ccy',
              columntype : 'textbox',
              datafield : 'currency',
              width : '50'
          }, {
              text : 'Broker',
              columntype : 'textbox',
              datafield : 'liquidityProviderDisplay',
              width : '80'
          }, {
              text : 'Contract Type',
              columntype : 'textbox',
              datafield : 'contractTypeDisplayName',
              width : '100'
          }, {
              text : 'Order Type',
              columntype : 'textbox',
              datafield : 'orderTypeDisplayName',
              width : '100'
          }, {
              text : 'Side',
              columntype : 'textbox',
              datafield : 'sideDisplayName',
              width : '50'
          }, {
              text : 'Quantity',
              columntype : 'textbox',
              datafield : 'orderQuantity',
              width : '80'
          }, {
              text : 'Spot Px',
              columntype : 'textbox',
              datafield : 'orderSpotPrice',
              width : '80'
          }, {
              text : 'Fwd Pts',
              columntype : 'textbox',
              datafield : 'orderForwardPoints',
              width : '80'
          }, {
              text : 'Outright Px',
              columntype : 'textbox',
              datafield : 'orderOutrightPrice',
              width : '80'
          }, {
              text : 'Executed',
              columntype : 'textbox',
              datafield : 'quantityExecuted',
              width : '80'
          }, {
              text : 'Value Date',
              columntype : 'datetimeinput',
              cellsformat: 'yyyy-MMM-dd',
              datafield : 'valueDate',
              width : '100'
          }];

          let initrowdetails = function(index, parentElement, gridElement, datarecord) {
              let tabsdiv = null;
              tabsdiv = $($(parentElement).children()[0]);
              $(tabsdiv).jqxTabs({
                  width : '100%',
                  height : '100%',
                  initTabContent : function(tab) {
                      switch (tab) {
                          case 0 :
                              initOrderUpdateTab("#jqxGridSummaryByOrderUpdates",datarecord.fxOrderUpdates);
                              break;
                          case 1 :
                              initSweepCriteriaTab(datarecord.ruleMatchEvent);
                              break;
                          case 2 :
                              if (datarecord.allocations !== undefined) {
                                  initOrderAllocationsTab("#jqxGridSummaryByAccountAllocations",datarecord.allocations);
                              }
                              break;
                      }
                  }
              });
              if (datarecord.allocations === undefined) {
                  $("#jqxGridSummaryByAccountAllocations").hide();
              }
          }
          settings.rowdetails = true;
          settings.initrowdetails = initrowdetails;
          settings.rowdetailstemplate = {
              rowdetails : "<div id='jqxTab' style='overflow: hidden;'>\
                              <ul>\
                                  <li style='margin-left: 30px;'>Order Updates</li>\
                                  <li>Exposure Evaluation Event</li>\
                                  <li>Account Allocations</li>\
                              </ul>\
                              <div style='overflow: hidden;'>\
                                  <div style='border:none' id='jqxGridSummaryByOrderUpdates'></div>\
                              </div>\
                              <div style='overflow: hidden;'>\
                                  <div style='border:none' id='sweepCriteriaMatch'></div>\
                              </div>\
                              <div style='overflow: hidden;'>\
                                  <div style='border:none' id='jqxGridSummaryByAccountAllocations'></div>\
                              </div>\
                          </div>",
              rowdetailsheight : 500,
              rowdetailshidden : true
          };

          $("#jqxGridFXOrdersByOrder").jqxGrid(settings);
      }

      function initOrderUpdateTab(gridName, data) {
          let source = {
              localdata : data,
              datafields : [{
                  name : 'updateTimestamp',
                  type : 'date',
                  format: 'yyyy-MM-dd HH:mm:ss.fff'
              }, {
                  name : 'orderState',
                  type : 'string'
              }, {
                  name : 'orderStateDisplayName',
                  type : 'string',
                  value: 'orderState',
                  values: {
                      source: constants.getTranslatedValues('resources.orderUpdate.state'),
                      value: 'value',
                      name: 'display'
                  }
              }, {
                  name : 'externalOrderId',
                  type : 'string'
              }, {
                  name : 'eventAction',
                  type : 'string'
              }, {
                  name : 'eventActionDisplayName',
                  type : 'string',
                  value: 'eventAction',
                  values: {
                      source: constants.getTranslatedValues('resources.fxOrderEvent.action'),
                      value: 'value',
                      name: 'display'
                  }
              }, {
                  name : 'liquidityProviderId',
                  type : 'string'
              }, {
                  name : 'liquidityProviderDisplay',
                  type : 'string',
                  value: 'liquidityProviderId',
                  values: {
                    source: liquidityProviders,
                    value: 'liquidityProviderId',
                    name: 'displayName'
                  }
              }, {
                  name : 'orderType',
                  type : 'string'
              }, {
                  name : 'orderTypeDisplayName',
                  type : 'string',
                  value: 'orderType',
                  values: {
                      source: constants.getTranslatedValues('resources.order.type'),
                      value: 'value',
                      name: 'display'
                  }
              }, {
                  name : 'orderQuantity',
                  type : 'string'
              }, {
                  name : 'orderSpotPrice',
                  type : 'string'
              }, {
                  name : 'orderForwardPoints',
                  type : 'string'
              }, {
                  name : 'orderOutrightPrice',
                  type : 'string'
              }, {
                  name : 'valueDate',
                  type : 'date',
                  format: 'yyyy-MM-dd'
              }, {
                  name : 'quoteId',
                  type : 'string'
              }, {
                  name : 'traderId',
                  type : 'string'
              }, {
                  name : 'updateId',
                  type : 'string'
              }, {
                  name : 'fillQuantity',
                  type : 'string'
              }, {
                  name : 'fillSpotPrice',
                  type : 'string'
              }, {
                  name : 'fillForwardPoints',
                  type : 'string'
              }, {
                  name : 'fillOutrightPrice',
                  type : 'string'
              }]
          };

          let settings = defaultGridViewSettings(gridName, source);
          settings.width = '97%';
          settings.height = '99%';
          settings.columns = [{
              text : 'Timestamp',
              columntype : 'datetimeinput',
              datafield : 'updateTimestamp',
              cellsformat : 'MM/dd/yyyy HH:mm:ss.fff',
              width : '150'
          }, {
              text : 'Order State',
              columntype : 'textbox',
              datafield : 'orderStateDisplayName',
              width : '120'
          }, {
              text : 'External Order ID',
              columntype : 'textbox',
              datafield : 'externalOrderId',
              width : '150'
          }, {
              text : 'Action',
              columntype : 'textbox',
              datafield : 'eventActionDisplayName',
              width : '200'
          }, {
              text : 'Broker',
              columntype : 'textbox',
              datafield : 'liquidityProviderDisplay',
              width : '120'
          }, {
              text : 'Order Type',
              columntype : 'textbox',
              datafield : 'orderTypeDisplayName',
              width : '100'
          }, {
              text : 'Order Qty',
              columntype : 'textbox',
              datafield : 'orderQuantity',
              width : '120'
          }, {
              text : 'Order Spot Px',
              columntype : 'textbox',
              datafield : 'orderSpotPrice',
              width : '120'
          }, {
              text : 'Order Fwd Pts',
              columntype : 'textbox',
              datafield : 'orderForwardPoints',
              width : '120'
          }, {
              text : 'Order Outright Px',
              columntype : 'textbox',
              datafield : 'orderOutrightPrice',
              width : '120'
          }, {
              text : 'Value Date',
              columntype : 'datetimeinput',
              datafield : 'valueDate',
              cellsformat : 'yyyy-MMM-dd',
              width : '120'
          }, {
              text : 'Quote ID',
              columntype : 'textbox',
              datafield : 'quoteId',
              width : '100'
          }, {
              text : 'Trader ID',
              columntype : 'textbox',
              datafield : 'traderId',
              width : '100'
          }, {
              text : 'External Trade ID',
              columntype : 'textbox',
              datafield : 'updateId',
              width : '120'
          }, {
              text : 'Trade Qty',
              columntype : 'textbox',
              datafield : 'fillQuantity',
              width : '100'
          }, {
              text : 'Trade Spot Px',
              columntype : 'textbox',
              datafield : 'fillSpotPrice',
              width : '120'
          }, {
              text : 'Trade Fwd Pts',
              columntype : 'textbox',
              datafield : 'fillForwardPoints',
              width : '100'
          }, {
              text : 'Trade Outright Px',
              columntype : 'textbox',
              datafield : 'fillOutrightPrice',
              width : '100'
          }];

          $(gridName).jqxGrid(settings);
      }

      function initSweepCriteriaTab(data) {
          let container = $('<div style="margin: 5px;"></div>');

          let leftcolumn = $('<div style="float: left; width: 45%;"></div>');
          container.append(leftcolumn);

          let ruleMatchEventActions = constants.getTranslatedValues('resources.ruleMatchEvent.action');
          let translatedAction = null;
          for(var i=0;i<ruleMatchEventActions.length;i++){
            if(ruleMatchEventActions[i].value == data.eventAction){
              translatedAction = ruleMatchEventActions[i].display;
              break;
            }
          }

          let timestamp = "<div style='margin: 10px;'><b>Time Stamp:</b> " + data.eventTimestamp + "</div>";
          let sweepCriteria = "<div style='margin: 10px;'><b>Exposure Evaluation Event:</b> " + translatedAction + "</div>";
          $(leftcolumn).append(timestamp);
          $(leftcolumn).append(sweepCriteria);

          container.appendTo($("#sweepCriteriaMatch"));
      }

  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/fx-orders-h/fx-orders-h.component.ts